import React, { useState, useEffect } from 'react'

import { useHistory } from "react-router-dom";

import { Column } from '@ant-design/charts';

import { Table, Tooltip,Tag, Input, Button, Space,message,Select} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import './styles.scss';

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import moment from 'moment'

import {GetOrders} from '../../../Redux/actions/orders'


const { Option } = Select;

const Index = ({currentData,seriesField,xField,yField}) => {

  const dispatch = useDispatch()   


    const [loading, setLoading] = useState(false)
    const [timeGrouping, setTimeGrouping] = useState('By Day')
    
    const [data, setData] = useState([])
  
   
    useEffect(() => {
      if(currentData){
        Analyze(currentData)     
       }
    },[currentData,timeGrouping]);
  
    const timeRangeRasterizer = (created_at) =>{
      const weekOfMonth =(input) => {
        const firstDayOfMonth = input.clone().startOf('month');
        const firstDayOfWeek = firstDayOfMonth.clone().startOf('week');
      
        const offset = firstDayOfMonth.diff(firstDayOfWeek, 'days');
      
        return Math.ceil((input.date() + offset) / 7);
      }

      switch(timeGrouping) {
        case "By Day":
          return(moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))
        case "By Week":
          var week =  weekOfMonth(moment(created_at, 'YYYY-MM-DD HH:mm:ss'))
          var month =  moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-M');
        
          var text = month +"-week-"+week
          return(text)
        case "By Month":
          var month =  moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-M');
          return(month)
  
        default:
          // code block
      }
    }

    const Analyze = (datum) =>{
      var timeList =[]
      var seriesList =[]
      var newDatum  = datum.map(item=>{
        var currentDateTime = timeRangeRasterizer(item.created_at)
        if(!timeList.includes(currentDateTime)){
          timeList.push(currentDateTime)
        }
        if(!seriesList.includes(item[seriesField])){
          seriesList.push(item[seriesField])
        }
        var newItem ={
          ...item,
          dateTime:currentDateTime
        }
        return(newItem)
      })
      
      var proccesedData = []

      timeList.map(time=>{
        seriesList.map(serie=>{
          var total = 0          
          newDatum.map(thing =>{
            if(thing.dateTime == time && thing[seriesField] == serie){
              total = total + thing[yField]
            }
          })
          var bago = {
            dateTime:time,
            [seriesField]:serie,            
            [yField]:total
          }
          proccesedData.push(bago)
        })
      })
      console.log('proccesedData',proccesedData)
      proccesedData = proccesedData.reverse()
      setData(proccesedData)

    }


    return(
      <div className="column_container">
        <div className="header">
          <div>
            <h1>{seriesField}-{yField}- Time </h1>
          </div>
          <div>
            <Select value={timeGrouping} style={{ width: 120 }} onChange={(e)=>{setTimeGrouping(e)}}>
              <Option value="By Day">By Day</Option>
              <Option value="By Week">By Week</Option>
              <Option value="By Month">By Month</Option>
            </Select>
          </div>
        </div>
       
        
        <Column 
          data={data.length>0 ? data: []}
          
          isGroup
          autoFit={true}
          style={{width:'100%'}}
          seriesField={seriesField}
          // xAxis={{
          //   type: timeGrouping =="By Week"? 'cat':'time',
          // }}
     
          xField={xField}
          yField={yField}
        
        />

      </div>
     
  
      
    )
}
  
export default Index
  